import {
  setCollectionBreakdownModal,
  setCollectionModal,
  showBankingCommentsModal,
  showSiteVarianceHistoryModal,
} from "@actions/modals";
import collections from "@api/collections";
import CommentsButton from "@buttons/CommentsButton";
import SummaryButton from "@buttons/SummaryButton";
import { handleDownload } from "@helpers/downloads";
import DataGrid from "@shared/DataGrid";
import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Dimmer,
  Dropdown,
  Grid,
  Header,
  Icon,
  Loader,
  Modal,
} from "semantic-ui-react";

class CollectionModal extends React.Component {
  state = {
    showSummary: true,
    loading: false,
    loadingReport: false,
  };

  handleRefresh = () => {
    this.setState({ loading: true }, () => {
      const { siteId, operator, batchId, periodId, isPerformance, fnLoad } = this.props.modal;
      
      const period = periodId || batchId;
      
      if (isPerformance) {
        Promise.all([
          collections.getBankingPerformanceDetailGrid(operator, siteId, period),
          collections.getBankingPerformanceCategoryGrid(operator, siteId, period),
          collections.getBankingPerformanceSummaryGrid(operator, siteId, period),
        ]).then(
          ([detailResponse, categoryResponse, summaryResponse]) => {
            const detailGrid = detailResponse.detailGrid || detailResponse;
            const categoryGrid = categoryResponse.categoryGrid || categoryResponse;
            const summaryGrid = summaryResponse.summaryGrid || summaryResponse;
            
            const metadata = detailResponse.detailGrid ? detailResponse : {};
            
            const emptyGrid = { headerDef: [], rowDef: [], data: [] };
            const result = {
              ...this.props.modal,
              ...metadata,
              detailGrid: detailGrid || emptyGrid,
              categoryGrid: categoryGrid || emptyGrid,
              summaryGrid: summaryGrid || emptyGrid,
            };
            
            this.props
              .setCollectionModal(result)
              .then(() => this.setState({ loading: false }));
          },
          () => this.setState({ loading: false }),
        );
      } else {
        Promise.all([
          collections.getBankingWeekDetailGrid(operator, siteId, period),
          collections.getBankingWeekKioskGrid(operator, siteId, period),
          collections.getBankingWeekSummaryGrid(operator, siteId, period),
        ]).then(
          ([detailResponse, kioskResponse, summaryResponse]) => {
            const detailGrid = detailResponse.detailGrid || detailResponse;
            const kioskGrid = kioskResponse.kioskGrid || kioskResponse;
            const summaryGrid = summaryResponse.summaryGrid || summaryResponse;
            
            const metadata = detailResponse.detailGrid ? detailResponse : {};
            
            const emptyGrid = { headerDef: [], rowDef: [], data: [] };
            const result = {
              ...this.props.modal,
              ...metadata,
              detailGrid: detailGrid || emptyGrid,
              kioskGrid: kioskGrid || emptyGrid,
              summaryGrid: summaryGrid || emptyGrid,
            };
            
            this.props
              .setCollectionModal(result)
              .then(() => this.setState({ loading: false }));
          },
          () => this.setState({ loading: false }),
        );
      }
    });
  };

  handleVarianceHistory = () => {
    this.props.showSiteVarianceHistoryModal(true);
  };

  onRowClick = (row) => {
    const { detailRef } = row;
    const fnLoad = this.props.modal.isPerformance
      ? collections.getBankingPerformanceByEgm
      : collections.getBankingWeekByEgm;
    this.props.setCollectionBreakdownModal({
      open: true,
      detailRef,
      fnLoad,
    });
  };

  handleClose = () => {
    this.props.setCollectionModal({ open: false });
  };

  handleViewComments = () => {
    const { operator, periodId, siteId } = this.props.modal;

    this.setState({ loading: true }, () => {
      collections.getComments(operator, periodId, siteId).then(
        (result) =>
          this.setState({ loading: false }, () =>
            this.props.showBankingCommentsModal(true, result),
          ),
        () => this.setState({ loading: false }),
      );
    });
  };

  requestFile = (fn) => {
    this.setState({ loadingReport: true }, () => {
      fn(this.props.modal.batchId).then(
        (response) =>
          this.setState({ loadingReport: false }, () =>
            handleDownload(response),
          ),
        () => this.setState({ loadingReport: false }),
      );
    });
  };

  handleVariancePdfClick = () => {
    const fn = this.props.modal.isPerformance
      ? collections.getPerformanceVariancePdf
      : collections.getBankingVariancePdf;
    this.requestFile(fn);
  };

  handleSummaryPdfClick = () => {
    const fn = this.props.modal.isPerformance
      ? collections.getPerformanceSummaryPdf
      : collections.getBankingSummaryPdf;
    this.requestFile(fn);
  };

  componentDidUpdate(prevProps) {
    const checkProps = [
      "operator",
      "siteId",
      "batchId",
      "isPerformance",
      "open",
    ];

    if (!this.props.modal.open) {
      return;
    }

    for (const prop of checkProps) {
      if (this.props.modal[prop] !== prevProps.modal[prop]) {
        this.handleRefresh();
        break;
      }
    }
  }

  render() {
    const { showFloatsGrid } = this.props.modal;
    const { showSummary, loading } = this.state;

    const rightWidth = showSummary ? 13 : 16;

    return (
      <Modal
        open={this.props.modal.open}
        onClose={this.handleClose}
        size="fullscreen"
        closeIcon
        style={{ height: "80%" }}
      >
        <Modal.Header>{this.props.modal.title}</Modal.Header>
        <Modal.Content className="h-100">
          {loading ? (
            <Dimmer inverted active>
              <Loader active content="Loading" />
            </Dimmer>
          ) : (
            <Grid className="height-100 flex-container">
              <Grid.Row>
                <Grid.Column width="8">
                  <SummaryButton
                    active={showSummary}
                    className="mr-1"
                    onClick={() => this.setState({ showSummary: !showSummary })}
                  />
                  <Header size="small" className="d-inline">
                    {this.props.modal.siteText} - {this.props.modal.weekText}
                  </Header>
                </Grid.Column>
                <Grid.Column width="8" textAlign="right">
                  {this.props.modal.optionShowViewCommentsButton && (
                    <CommentsButton
                      onClick={this.handleViewComments}
                      content="View Comments"
                    />
                  )}
                  <Dropdown
                    direction="left"
                    icon={null}
                    trigger={
                      <Button
                        color="teal"
                        icon
                        labelPosition="right"
                        loading={this.state.loadingReport}
                      >
                        <Icon name="caret down" /> Reports
                      </Button>
                    }
                  >
                    <Dropdown.Menu>
                      <Dropdown.Item
                        text="Summary Report PDF"
                        onClick={() =>
                          this.requestFile(collections.getSummaryReportPdf)
                        }
                      />
                      <Dropdown.Item
                        text={
                          this.props.modal.isPerformance
                            ? "Net Income PDF"
                            : "Banking Report PDF"
                        }
                        onClick={this.handleSummaryPdfClick}
                      />
                      {this.props.modal.isPerformance && (
                        <Dropdown.Item
                          text="Net Income CSV"
                          onClick={() =>
                            this.requestFile(
                              collections.getPerformanceSummaryCsv,
                            )
                          }
                        />
                      )}
                      <Dropdown.Item
                        text="Collection Variance PDF"
                        onClick={this.handleVariancePdfClick}
                      />
                    </Dropdown.Menu>
                  </Dropdown>
                </Grid.Column>
              </Grid.Row>
              {this.props.modal.isPerformance && (
                <Grid.Row>
                  <Grid.Column
                    width={
                      this.props.modal.isPerformance || !showFloatsGrid
                        ? "16"
                        : "13"
                    }
                  >
                    {this.props.modal.categoryGrid && (
                      <DataGrid
                        headings={this.props.modal.categoryGrid.headerDef}
                        data={this.props.modal.categoryGrid.data}
                        loading={this.state.loading}
                        rowDef={this.props.modal.categoryGrid.rowDef}
                        onRowClick={() => {}}
                        style={{ maxHeight: "120px" }}
                      />
                    )}
                  </Grid.Column>
                  {showFloatsGrid && this.props.modal.siteFloatGrid && (
                    <Grid.Column width="3">
                      <DataGrid
                        headings={this.props.modal.siteFloatGrid.headerDef}
                        data={this.props.modal.siteFloatGrid.data}
                        rowDef={this.props.modal.siteFloatGrid.rowDef}
                        loading={this.state.loading}
                        onRowClick={() => {}}
                        style={{ maxHeight: "120px" }}
                      />
                    </Grid.Column>
                  )}
                </Grid.Row>
              )}
              <Grid.Row className="flex-stretch">
                {showSummary && this.props.modal.summaryGrid && (
                  <Grid.Column
                    width="3"
                    className="flex-stretch gs-flex-container-vertical"
                  >
                    <DataGrid
                      headings={this.props.modal.summaryGrid.headerDef}
                      data={this.props.modal.summaryGrid.data}
                      rowDef={this.props.modal.summaryGrid.rowDef}
                      loading={this.state.loading}
                      fullHeight
                      onRowClick={() => {}}
                    />
                  </Grid.Column>
                )}
                <Grid.Column
                  width={rightWidth}
                  className="flex-stretch gs-flex-container-vertical"
                >
                  {this.props.modal.detailGrid && (
                    <DataGrid
                      headings={this.props.modal.detailGrid.headerDef}
                      data={this.props.modal.detailGrid.data}
                      rowDef={this.props.modal.detailGrid.rowDef}
                      loading={this.state.loading}
                      fullHeight
                      onRowClick={this.onRowClick}
                    />
                  )}
                  {!this.props.modal.isPerformance && this.props.modal.kioskGrid && (
                    <div className="mt-1">
                      <Header size="small">Kiosk/Cash Desk Summary</Header>
                      <DataGrid
                        headings={this.props.modal.kioskGrid.headerDef}
                        data={this.props.modal.kioskGrid.data}
                        rowDef={this.props.modal.kioskGrid.rowDef}
                        onRowClick={() => {}}
                        loading={this.state.loading}
                        style={{ maxHeight: "120px" }}
                      />
                    </div>
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          )}
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.collectionModal,
    breakdown: state.collectionBreakdownModal,
  };
};

export default connect(mapStateToProps, {
  showBankingCommentsModal,
  setCollectionBreakdownModal,
  showSiteVarianceHistoryModal,
  setCollectionModal,
})(CollectionModal);
